import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ServicingFeedQuery } from 'app/state/ducks/servicing/types'
import {
  getServicingLoader,
  isServicingStale,
} from 'app/state/ducks/servicing/selectors'
import { loadServicingEvents } from 'app/state/ducks/servicing/thunks'

/**
 * Keeps the servicing store on the given window: one read on mount (and
 * when `to` changes), and one more whenever a write has made the store
 * stale, at once — the store lays its remembered writes over the answer, so
 * a read that predates their projection cannot undo them (reducer.ts).
 */
export function useServicingFeed(
  query: ServicingFeedQuery = {},
  { enabled = true }: { enabled?: boolean } = {},
) {
  const dispatch = useDispatch()
  const isLoading = useSelector(getServicingLoader)
  const stale = useSelector(isServicingStale)
  const to = query.to

  // `enabled` holds the read back until its window is known: My Work frames
  // `to` on the business date, and reading on the today-fallback first would
  // read (and price fees) twice (LOS-7219)
  useEffect(() => {
    if (enabled) dispatch(loadServicingEvents({ to }) as any)
  }, [dispatch, to, enabled])

  useEffect(() => {
    if (enabled && stale && !isLoading)
      dispatch(loadServicingEvents({ to }) as any)
  }, [stale, isLoading, enabled])
}
